import { Module } from "vuex"
import firebase from "firebase"
import { RootState, Collection, CollectionsState } from "../types"

const FIREBASE_COLL = process.env.VUE_APP_COLLECTIONS

const collectionsModule: Module<CollectionsState, RootState> = {
  namespaced: true,
  state: {
    collections: []
  },

  mutations: {
    setCollections(state: any, payload: Array<Collection>) {
      state.collections = payload
    }
  },

  actions: {
    fetch({ commit }) {
      const colRef = firebase.firestore().collection(FIREBASE_COLL)
      colRef
        .get()
        .then(data => {
          const collections: Array<any> = []
          data.forEach(collection => {
            collections.push(collection.data())
          })
          commit("setCollections", collections)
        })
    },

    create({ dispatch }, payload: Collection) {
      this.dispatch("app/showIsLoading")
      const colRef = firebase.firestore().collection(FIREBASE_COLL)
      payload["id"] = colRef.doc().id

      colRef
        .doc(payload.id)
        .set(payload)
        .then(() => {
          this.dispatch("app/showIsSuccess")
          dispatch("fetch")
        })
        .catch(() => {
          this.dispatch("app/showIsError")
        })
    },

    update({ dispatch }, payload: Collection) {
      this.dispatch("app/showIsLoading")
      const colRef = firebase.firestore().collection(FIREBASE_COLL)
      colRef
        .doc(payload.id)
        .update(payload)
        .then(() => {
          this.dispatch("app/showIsSuccess")
          dispatch("fetch")
        })
        .catch(() => {
          this.dispatch("app/showIsError")
        })
    },

    delete({ dispatch }, payload: Collection) {
      this.dispatch("app/showIsLoading")
      const colRef = firebase.firestore().collection(FIREBASE_COLL)
      colRef
        .doc(payload.id)
        .delete()
        .then(() => {
          this.dispatch("app/showIsSuccess")
          dispatch("fetch")
        })
        .catch(() => {
          this.dispatch("app/showIsError")
        })
    }
  },

  getters: {
    getCollections: function(state: any): Array<Collection> {
      return state.collections
    }
  }
}

export default collectionsModule
